import React from 'react';

import {ScoresListHeaderModuleMobilePlaceholder} from "./mobile/scores-list-header-module.mobile.placeholder";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ScoresListWidgetDesktopHeaderPlaceholder} from "../../../core/components/scores-header/placeholders/scores-header.placeholder";

export class ScoresListHeaderModulePlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresListHeaderModulePlaceholder = (props: ScoresListHeaderModulePlaceholderProps) => {
  return (
    <React.Fragment>
      {
        !props.device.isLargeView && <ScoresListHeaderModuleMobilePlaceholder {...props} />
      }
      {
        props.device.isLargeView && <ScoresListWidgetDesktopHeaderPlaceholder {...props} />
      }
    </React.Fragment>
  )
};
